export enum BootstrapLoadingState {
    Loading,
    LoadedSuccessfully,
    LoadFailed
}
